import React from "react";
import { Alert, Text } from "@chakra-ui/react";
import { DocumentData, WithFieldValue } from "firebase/firestore";

import { PRODUCTION_STEPS_AUX } from "@constants";
import { ButtonModal, JsonForm, JsonFormControl } from "@components";
import { useCustomToast } from "@hooks";

import { makeCommentsControl } from "../JsonForm";
import { useAddAuxStep } from "./useAddAuxStep";

const AddCommentFormFields: JsonFormControl[] = [makeCommentsControl()];

type AddCommentModalProps = {
  itemId: string;
};

export function AddCommentModal({ itemId }: AddCommentModalProps) {
  const addCommentToast = useCustomToast(() => (
    <Alert status="success">Comments Added!</Alert>
  ));
  const [error, setError] = React.useState("");
  const addStep = useAddAuxStep(
    itemId,
    PRODUCTION_STEPS_AUX.STEP_AUX_COMMENT,
    addCommentToast,
    setError,
  );
  const doSubmit = React.useCallback(
    async function <T extends WithFieldValue<DocumentData>>(data: T) {
      // Coerce data from Json Form Callback.
      const comments = data.comments ? (data.comments as string) : "";
      addStep(comments);
    },
    [addStep],
  );

  return (
    <ButtonModal label="Add Comment" title="Add Comment" size="sm">
      <JsonForm
        fields={AddCommentFormFields}
        onSubmit={doSubmit}
        clearAfterSubmit
      />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
